import * as _ from "lodash";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { profileService } from "../../services/profile.service";

export const getListProfile = createAsyncThunk(
  "profileManage/getListProfile",
  async (filter, { rejectWithValue }) => {
    try {
      const response = await profileService.getListProfile(filter);

      return _.get(response, "data", []);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const readProfile = createAsyncThunk(
  "profileManage/readProfile",
  async (id, { rejectWithValue }) => {
    try {
      const response = await profileService.readProfile(id);

      return _.get(response, "data", {});
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const readProfileByDomain = createAsyncThunk(
  "profileManage/readProfileByDomain",
  async (domain, { rejectWithValue }) => {
    try {
      const response = await profileService.readProfileByDomain(domain);

      return _.get(response, "data", {});
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const readProfileByDomainWidget = createAsyncThunk(
  "profileManage/readProfileByDomainWidget",
  async (domain, { rejectWithValue }) => {
    try {
      const response = await profileService.readProfileByDomainWidget(domain);

      return _.get(response, "data", {});
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const addProfile = createAsyncThunk(
  "profileManage/addProfile",
  async ({ data, isFormData }, { rejectWithValue }) => {
    try {
      const response = await profileService.addProfile(data, isFormData);

      return _.get(response, "data", {});
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const editProfile = createAsyncThunk(
  "profileManage/editProfile",
  async ({ id, data, isFormData }, { rejectWithValue }) => {
    try {
      const response = await profileService.editProfile(id, data, isFormData);

      return _.get(response, "data", {});
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const removeProfile = createAsyncThunk(
  "profileManage/removeProfile",
  async (id, { rejectWithValue }) => {
    try {
      const response = await profileService.removeProfile(id);

      return _.get(response, "data", {});
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getProfileAllowed = createAsyncThunk(
  "profileManage/getProfileAllowed",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await profileService.getProfileAllowed();

      return _.get(response, "data", []);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getListTimeZone = createAsyncThunk(
  "profileManage/getListTimeZone",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await profileService.getListTimeZone();

      return _.get(response, "data", []);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
